module.exports = __webpack_public_path__ + "img/front.19022428.jpg";